const translations = {
    es: {
        // Títulos y etiquetas
        name: "Nombre",
        description: "Descripción",
        model: "Modelo",
        days: "Días",
        params: "Parámetros",
        dist: "Distancia",
        bat: "Bateria",
        sacc: "Acelerometro",
        signal: "Señal",
        temp: "Temperatura",
        difloc: "Localización",
        difvac: "Vaciado",
        difllen: "Llenado",
        "create.title": "Crear configuración de alertas",
        "edit.title": "Editar configuración de alertas",
        active: "Activo",
        updated: "Actualizado",

        // Alertas específicas
        "fields.no_send": "Alerta de no envío",
        "fields.no_send.short": "Días NE",
        "fields.no_send.description": "Aviso de contenedores que llevan un tiempo sin enviar medidas",
        "fields.no_send.params": "Días",
        //
        "fields.dist": "Alerta de llenado",
        "fields.dist.description": "Porcentaje de llenado del contenedor ha aumentado mas de...",
        "fields.dist.params": "Nivel (%)",
        //
        "fields.bat": "Nivel de Bateria",
        "fields.bat.short": "Bateria",
        "fields.bat.description": "Se dispará si detecta un nivel menor a la indicado.",
        "fields.bat.params": "Nivel (%)",
        //
        "fields.sacc": "Acelerometro",
        "fields.sacc.short": "Acelerometro",
        "fields.sacc.description": "Se dispará si detecta aceleración mayor a la indicado.",
        "fields.sacc.params": "Fuerza G",
        //
        "fields.temp": "Temperatura",
        "fields.temp.short": "Temperatura",
        "fields.temp.description": "Se dispará si detecta una temperatura mayor a la indicada.",
        "fields.temp.params": "°C",
        // -
        "fields.nivel_llenado_a": "Alerta de llenado (Activa)",
        "fields.nivel_llenado_a.short": "Llenado A",
        "fields.nivel_llenado_a.description": "El porcentaje para activar la alerta de llenado es de ...",
        "fields.nivel_llenado_a.params": "Activa (%)",
        //
        "fields.nivel_llenado_d": "Alerta de llenado (Desactiva)",
        "fields.nivel_llenado_d.short": "Llenado D",
        "fields.nivel_llenado_d.description": "El porcentaje para desactivar la alerta de llenado es de ...",
        "fields.nivel_llenado_d.params": "Desactiva (%)",
        //
        "fields.difllen": "Llenado rápido",
        "fields.difllen.short": "Llenado R",
        "fields.difllen.description": "Diferencia de llenado en porcentaje entre dos medidas consecutivas. (durante el llenado).",
        "fields.difllen.params": "Dif. Nivel (%)",
        //
        "fields.difvac": "Vaciado rápido",
        "fields.difvac.short": "Vaciado R",
        "fields.difvac.description": "Diferencia de vaciado en porcentaje entre dos medidas consecutivas. (durante el vaciado).",
        "fields.difvac.params": "Dif. Nivel (%)",
        //
        "fields.t_volcado": "Tiempo volcado",
        "fields.t_volcado.short": "Volcado",
        "fields.t_volcado.description": "Segundos tras la detección de un volcado.",
        "fields.t_volcado.params": "Segundos",
        //
        "fields.t_mov_permanente": "Tiempo de movimiento permanente",
        "fields.t_mov_permanente.short": "Movimiento",
        "fields.t_mov_permanente.description": "Minutos con movimiento permanente detectado.",
        "fields.t_mov_permanente.params": "Minutos",
        //
        "fields.angulo_a": "Angulo activa",
        "fields.angulo_a.short": "Angulo A",
        "fields.angulo_a.description": "Angulo (º) para la activación (mayor que).",
        "fields.angulo_a.params": "Mayor que (º) - Angulo",
        //
        "fields.angulo_d": "Angulo desactivado",
        "fields.angulo_d.short": "Angulo D",
        "fields.angulo_d.description": "Angulo (º) para desactivar (menor que).",
        "fields.angulo_d.params": "Menor que (º) - Angulo",
        //
        "fields.alta_temp_a": "Alta temperatura (activa)",
        "fields.alta_temp_a.short": "Alta Temp. A",
        "fields.alta_temp_a.description": "Limite de alta temperatura para la activación",
        "fields.alta_temp_a.params": "Mayor que ºC",
        //
        "fields.alta_temp_d": "Alta temperatura (desactiva)",
        "fields.alta_temp_d.short": "Alta Temp. D",
        "fields.alta_temp_d.description": "Limite que desactiva la alta temperatura",
        "fields.alta_temp_d.params": "Menor que ºC",
        //
        "fields.baja_temp_a": "Baja temperatura (activa)",
        "fields.baja_temp_a.short": "Baja Temp. A",
        "fields.baja_temp_a.description": "Limite que activa la baja temperatura",
        "fields.baja_temp_a.params": "Menor que ºC",
        //
        "fields.baja_temp_d": "Baja temperatura (desactiva)",
        "fields.baja_temp_d.short": "Baja Temp. D",
        "fields.baja_temp_d.description": "Limite de baja temperatura para desactivar",
        "fields.baja_temp_d.params": "Mayor que ºC",
        //
        "fields.incendio": "Incendio",
        "fields.incendio.short": "Incendio",
        "fields.incendio.description": "Regulación del sensor infrarrojo para activar la alerta.",
        "fields.incendio.params": "-",
        //
        "fields.height": "Altura",
        "fields.height.short": "Altura",
        "fields.height.description": "Altura del contenedor.",

        // Botones
        "button.accept": "Aceptar",
        "button.save": "Guardar",
        "button.cancel": "Cancelar",

        // Mensajes de éxito
        "message.success.title": "Operación correcta",
        "message.success.text": "Se ha guardado correctamente",

        // Mensajes de error
        "message.error.service": "Error en el servicio",
        "message.error.retrieve": "No se han podido recuperar la alerta",
        "message.error.server": "Error en el servidor",
        "message.error.admin": "Consultar con el administrador",
        "message.error.id": "El id enviado no está accesible",
        "message.error.save": "Error en el servicio de guardar",
        "message.value.range": "El valor tiene que estar entre {min}-{max}",
        "message.error.required.name": "El campo nombre es obligatorio",
    },
    en: {
        // Títulos y etiquetas
        name: "Name",
        description: "Description",
        model: "Model",
        days: "Days",
        params: "Parameters",
        dist: "Distance",
        bat: "Battery",
        sacc: "Accelerometer",
        signal: "Signal",
        temp: "Temperature",
        difloc: "Location",
        difvac: "Vacuum",
        difllen: "Filling",
        "create.title": "Create alerts configuration",
        "edit.title": "Edit alerts configuration",
        active: "Active",
        updated: "Updated",

        // Alertas específicas
        "fields.no_send": "No transmission alert",
        "fields.no_send.short": "Days NS",
        "fields.no_send.description": "Notification for containers that have not sent measurements for some time",
        "fields.no_send.params": "Days",
        // -
        "fields.dist": "Filling alert",
        "fields.dist.description": "The container's filling percentage has increased more than ...",
        "fields.dist.params": "Percentage (%)",
        //
        "fields.bat": "Battery level",
        "fields.bat.short": "Battery",
        "fields.bat.description": "Will trigger if it detects a level lower than the indicated.",
        "fields.bat.params": "Level (%)",
        //
        "fields.sacc": "Accelerometer",
        "fields.sacc.short": "Accelerometer",
        "fields.sacc.description": "Will trigger if it detects acceleration greater than the indicated.",
        "fields.sacc.params": "G-force",
        //
        "fields.temp": "Temperature",
        "fields.temp.short": "Temperature",
        "fields.temp.description": "Will trigger if it detects a temperature greater than the indicated.",
        "fields.temp.params": "°C",
        //
        "fields.nivel_llenado_a": "Filling alert (Activate)",
        "fields.nivel_llenado_a.short": "Filling A",
        "fields.nivel_llenado_a.description": "The percentage to activate the filling alert is of ...",
        "fields.nivel_llenado_a.params": "Activate (%)",
        //
        "fields.nivel_llenado_d": "Filling alert (Deactivate)",
        "fields.nivel_llenado_d.short": "Filling",
        "fields.nivel_llenado_d.description": "The percentage to deactivate the filling alert is of ...",
        "fields.nivel_llenado_d.params": "Deactivate (%)",
        //
        "fields.difllen": "Fast filling",
        "fields.difllen.short": "Fast Fill.",
        "fields.difllen.description": "Percentage difference in fill between two consecutive measurements (during filling).",
        "fields.difllen.params": "Difference (%)",
        //
        "fields.difvac": "Fast vacuum",
        "fields.difvac.short": "Fast Vac.",
        "fields.difvac.description": "Percentage difference in vacuum between two consecutive measurements (during vacuum).",
        "fields.difvac.params": "Difference (%)",
        //
        "fields.t_volcado": "Time of dump",
        "fields.t_volcado.short": "Dump",
        "fields.t_volcado.description": "Seconds after a dump is detected.",
        "fields.t_volcado.params": "Seconds",
        //
        "fields.t_mov_permanente": "Time of permanent movement",
        "fields.t_mov_permanente.short": "Movement",
        "fields.t_mov_permanente.description": "Minutes with permanent movement detected.",
        "fields.t_mov_permanente.params": "Minutes",
        //
        "fields.angulo_a": "Angle activation",
        "fields.angulo_a.short": "Angle A",
        "fields.angulo_a.description": "Angle (°) for activation (greater than).",
        "fields.angulo_a.params": "Greater than (°) - Angle",
        //
        "fields.angulo_d": "Angle deactivation",
        "fields.angulo_d.short": "Angle D",
        "fields.angulo_d.description": "Angle (º) for deactivation (less than).",
        "fields.angulo_d.params": "Less than (º) - Angle",
        //
        "fields.alta_temp_a": "High temperature alert",
        "fields.alta_temp_a.short": "High Temp. A",
        "fields.alta_temp_a.description": "Will trigger if the temperature exceeds the indicated.",
        "fields.alta_temp_a.params": "Greater than ºC",
        //
        "fields.alta_temp_d": "High temperature deactivation",
        "fields.alta_temp_d.short": "High Temp. D",
        "fields.alta_temp_d.description": "Will trigger if the temperature falls below the indicated.",
        "fields.alta_temp_d.params": "Less than ºC",
        //
        "fields.baja_temp_a": "Low temperature alert",
        "fields.baja_temp_a.short": "Low Temp. A",
        "fields.baja_temp_a.description": "Will trigger if the temperature falls below the indicated.",
        "fields.baja_temp_a.params": "Less than ºC",
        //
        "fields.baja_temp_d": "Low temperature deactivation",
        "fields.baja_temp_d.short": "Low Temp. D",
        "fields.baja_temp_d.description": "Will trigger if the temperature exceeds the indicated.",
        "fields.baja_temp_d.params": "Greater than ºC",
        //
        "fields.incendio": "Fire alarm",
        "fields.incendio.short": "Fire",
        "fields.incendio.description": "Regulation of the infrared sensor to activate the alert.",
        "fields.incendio.params": "-",
        //
        "fields.height": "Height",
        "fields.height.short": "Height",
        "fields.height.description": "Height of the container.",

        // Botones
        "button.accept": "Accept",
        "button.save": "Save",
        "button.cancel": "Cancel",

        // Mensajes de éxito
        "message.success.title": "Operation successful",
        "message.success.text": "Successfully saved",

        // Mensajes de error
        "message.error.service": "Service error",
        "message.error.retrieve": "Could not retrieve the alert",
        "message.error.server": "Server error",
        "message.error.admin": "Contact the administrator",
        "message.error.id": "The ID sent is not accessible",
        "message.error.save": "Error in save service",
        "message.value.range": "Value must be between {min}-{max}",
        "message.error.required.name": "The field name is mandatory",
    },
};

export default translations;
